<mat-sidenav-container class="h-[calc(100vh-96px)] !fixed !z-50">
    <mat-sidenav #sidenav mode="side" closed>
        <!-- Sidenav content goes here -->
            <div class="h-full py-2">
            <button class=" !absolute right-4 pt-1 px-2 !text-(--pg-brand-red)  aspect-square rounded-4xl  hover:!bg-(--pg-brand-red)/90 hover:!text-(--pg-text-light) hover:!cursor-pointer !transition-all !duration-200 ease-in" (click)="sidenav.toggle()">
                <mat-icon>close</mat-icon>
            </button>
            <br/>
            <br/>
            <mat-action-list>
                @for (item of items; track $index;){
                    @if (item.validPermission) {
                        @if (item.children && item.children.length > 0) {
                             <button mat-list-item (click)="navigateTo(item.route!)" [matMenuTriggerFor]="subMenu" class="my-3 active:!bg-(--pg-brand-red) active:!text-(--pg-text-light) hover:!bg-(--pg-brand-red) hover:!text-(--pg-text-light) hover:!cursor-pointer">
                                <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
                                <span matListItemTitle class="!font-bold hover:!text-(--pg-text-light)">{{ item.title }}</span>
                            </button>
                            <mat-menu #subMenu="matMenu">
                                        <nav-menu-items
                                            [items]="item.children"
                                            (navigate)="navigateTo($event)" />
                                    </mat-menu>
                        } @else{
                            <a mat-list-item (click)="navigateTo(item.route!)" class="my-3 active:!bg-(--pg-brand-red) active:!text-(--pg-text-light) hover:!bg-(--pg-brand-red) hover:!text-(--pg-text-light) hover:!cursor-pointer">
                                <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
                                <span matListItemTitle class="!font-bold hover:!text-(--pg-text-light)">{{ item.title }}</span>
                            </a>
                        }
                    }
                } 
            </mat-action-list>
            </div>
    </mat-sidenav>
    <mat-sidenav-content>
        <!-- Main content goes here -->
         <mat-nav-list>
            
         </mat-nav-list>
    </mat-sidenav-content>
</mat-sidenav-container>

@if(verifyPermissions.isAuthenticated()){
    <button matFab class=" !absolute !bottom-12 left-4 z-10 !bg-(--pg-brand-red) !text-white xl:!hidden" (click)="sidenav.toggle()">
        <mat-icon>menu</mat-icon>
    </button>
}